import { CSV_CATALOG } from '../generated/csvPaths';

const DB_NAME = 'verif_scores_career_v1';
const STORE_NAME = 'seasonData';
const CACHE_KEY = 'all';

function openDatabase() {
	return new Promise((resolve, reject) => {
		if (typeof indexedDB === 'undefined') {
			reject(new Error('IndexedDB indisponible'));
			return;
		}
		const request = indexedDB.open(DB_NAME, 1);
		request.onerror = () => reject(request.error ?? new Error('IndexedDB open failed'));
		request.onupgradeneeded = () => {
			const db = request.result;
			if (!db.objectStoreNames.contains(STORE_NAME)) {
				db.createObjectStore(STORE_NAME);
			}
		};
		request.onsuccess = () => resolve(request.result);
	});
}

function getCatalogFingerprint() {
	return CSV_CATALOG?.generatedAt ?? 'unknown';
}

export function getCareerCacheFingerprint() {
	return getCatalogFingerprint();
}

export async function readCachedCareerData(fingerprint = getCatalogFingerprint()) {
	try {
		const db = await openDatabase();
		return new Promise((resolve, reject) => {
			const tx = db.transaction(STORE_NAME, 'readonly');
			const store = tx.objectStore(STORE_NAME);
			const request = store.get(CACHE_KEY);
			request.onerror = () => reject(request.error);
			request.onsuccess = () => {
				const entry = request.result;
				if (!entry || entry.fingerprint !== fingerprint) {
					resolve(null);
					return;
				}
				resolve(entry.data ?? null);
			};
			tx.oncomplete = () => db.close();
		});
	} catch {
		return null;
	}
}

export async function writeCachedCareerData(data, fingerprint = getCatalogFingerprint()) {
	try {
		const db = await openDatabase();
		return new Promise((resolve, reject) => {
			const tx = db.transaction(STORE_NAME, 'readwrite');
			const store = tx.objectStore(STORE_NAME);
			const request = store.put({ fingerprint, data, cachedAt: Date.now() }, CACHE_KEY);
			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(true);
			tx.oncomplete = () => db.close();
		});
	} catch {
		return false;
	}
}

export async function clearCareerDataCache() {
	try {
		const db = await openDatabase();
		return new Promise((resolve, reject) => {
			const tx = db.transaction(STORE_NAME, 'readwrite');
			const store = tx.objectStore(STORE_NAME);
			const request = store.delete(CACHE_KEY);
			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(true);
			tx.oncomplete = () => db.close();
		});
	} catch {
		return false;
	}
}
